import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useState, useEffect } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp"; // Or use an image if you have one
import { BUTTON_COLOR } from "../../utils/constant";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import user from "../../assets/images/user.png";
import CircularProgress from "@mui/material/CircularProgress";
import { get_customer_list } from "../../utils/customer_helper";
import SignInPopup from "../login/SignInPopup";
import { useNavigate } from "react-router-dom";
import { hexToCSSFilter } from "hex-to-css-filter";

export default function CartAddress(props) {
  const phoneNumber = "8178316798";

  const { reducer, cartProps ,openUserInfo, setOpenUserInfo } = props;
  const { customer, last_order } = reducer;
  const storeInfo = props.sessionReducer?.store_details;
  const storeInfoConfig = props.sessionReducer?.store_config;
  const navigate = useNavigate();
  const [userIcon, setUserIcon] = useState(false);



 
    let storeCurrency = storeInfo?.store_currency;
const [currency, setCurrency] = useState(() => {
  switch (storeCurrency) {
    case "INR":
      return "₹";
    case "USD":
      return "$";
    case "CAD":
      return "$";
    case "OMR":
      return "OMR ";
    case "AED":
      return "AED ";
    default:
      return "$"; // default to dollar if no match
  }
});


  
  let CustomerAddress =  storeInfoConfig?.web_ordering_setting?.is_customer_screen_qr;
  let primaryColor = storeInfoConfig?.general_config?.primary_color || storeInfo?.primary_color || BUTTON_COLOR;
  let filterStyle = "";
  try {
    if (primaryColor && primaryColor.startsWith("#")) {
      filterStyle = hexToCSSFilter(primaryColor).filter;
    }
  } catch (e) {
    console.error(e);
  }

  const [goToCart, setGoToCart] = useState(false);
  const [guest, setGuest] = useState(false);
  const [isReload, setIsReload] = useState(true);
  const [allitem, setAllitem] = useState([]);
  const [itemVerriantList, setItemVerriantList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modifierPopup, setModifierPopup] = useState(false);
  const fetchData = async () => {
    try {
      const resp = await get_customer_list({
        cust_mobile: customer?.cust_mobile,
      });
      let customer_resp = {};
      if (resp?.customer_details?.length) {
        customer_resp = resp;
        props?.set_last_order({ ...customer_resp });
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };



  return (
    <>
      <SignInPopup
        {...props}
        {...{
          openUserInfo,
          userIcon,
          setOpenUserInfo,
          storeInfo,
          storeInfoConfig,
          guest,
          goToCart,
        }}
      />
               {CustomerAddress ?
      <Grid
        style={{
          display: "flex",
          alignItems: "center",
        }}
        container
      >
        <Grid
          container
          xs={12}
          style={{
            margin: "15px 4% 15px 4%",
            borderRadius: "8px",
            background: "white",
            padding: "1rem 0rem",
            boxShadow: "rgba(50, 50, 71, 0.04) 0px -1px 10px 10px",
          }}
        >
          <Grid item xs={2} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img
              alt="User Icon"
              src={user}
              style={{
                width: "60%",
                height: "auto",
                filter: filterStyle || "none",
              }}
            />
          </Grid>

          <Grid
            style={{
              textAlign: "left",
            }}
            item
            xs={7}
          >
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                color: "#000",
                marginBottom: "2px",
              }}
            >

          {customer?.guest == "Guest" ? "Guest User" : customer?.cust_first_name}
            </Typography>
            <span
              style={{
                fontWeight: "500",
                color: "#000",
                fontSize: "14px",
              }}
            >
                {customer?.guest == "Guest" ? "Login to manage account" : customer?.cust_mobile}         
            </span>
          </Grid>

          {/* Change Button */}
          <Grid item xs={3}>
            <Typography
              onClick={() => setOpenUserInfo(true)}
              style={{
                color: primaryColor,
                fontWeight: "bold",
                cursor: "pointer",
                textAlign: "right",
                paddingRight: "15%",
                fontSize: "14px",
              }}
            >
            {customer?.guest == "Guest" ? "Login" :"Change" }  
            </Typography>
          </Grid>
        </Grid>
      </Grid>:""}
    </>
  );
}
